<!-- <h3 mat-dialog-title>ADS</h3> -->
<!-- <button mat-button mat-dialog-close>Close</button> -->
<mat-dialog-content class="p-0">
  <h1>สำเร็จ</h1>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>ปิด</button>
</mat-dialog-actions>
